import { Injectable } from '@angular/core';
import { NgEntityService } from '@datorama/akita-ng-entity-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map } from 'rxjs/operators';

import { SocialMediaSearch } from '../../model/social-media-search';
import { UrlConfig } from '../../model/urlconfig';
import { HttpOptions, UpdateActionType } from '../../service/generic-akita-http.service';
import { WebsocketService } from '../../service/websocket.service';
import { encodeFiwareString } from '../../shared/replacer-util';
import { SocialMediaSearchState, SocialMediaSearchStore } from '../state/social-media-search.store';
import { AkitaSocialMediaSearchhHttpService } from './akita-http-socialmedia-search.service';


@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class SocialMediaSearchService extends NgEntityService<SocialMediaSearchState> implements UrlConfig {

  constructor(
    protected store: SocialMediaSearchStore,
    private socicalMediaSearchHttpService: AkitaSocialMediaSearchhHttpService,
    private webSocketService: WebsocketService,
  ) {
    super(store);

    this.webSocketService.getDataStream('SocialMediaSearch')
      .pipe(untilDestroyed(this))
      .subscribe((data: SocialMediaSearch[]) => {
        for (const search of data) {
          if (search.deleted) { this.store.remove(search.id); }
          else { this.store.upsertMany([search]); }
        }
      });
  }
  updateEntitiesUrl(newUrl: string): void {
    this.socicalMediaSearchHttpService.setEntitiesUrl(newUrl);
  }

  addSearch(search: SocialMediaSearch) {
    this.store.add(search);
    this.addSearchToFiware(search);
  }

  updateSearch(search: SocialMediaSearch) {
    this.store.update(search.id, search);
    this.addSearchToFiware(search);
  }

  addSearchToFiware(search: SocialMediaSearch) {
    const options: HttpOptions = {
      params: {
        options: 'keyValues'
      }
    };

    const encodeSearchPhrase = encodeFiwareString(search.searchPhrase);

    const copy = { ...search };
    copy.searchPhrase = encodeSearchPhrase;
    copy.name = encodeFiwareString(search.name);
    copy.errorMessage = encodeFiwareString(search.errorMessage);
    copy.dateLastModified = new Date().toISOString();

    this.socicalMediaSearchHttpService.update(copy, UpdateActionType.APPEND, options)
      .subscribe(data => console.log('updated search', data));
  }

  deleteSearch(search: SocialMediaSearch) {
    this.store.remove(search.id);

    const encodeSearchPhrase = encodeFiwareString(search.searchPhrase);
    const copy = { ...search };
    copy.searchPhrase = encodeSearchPhrase;
    copy.name = encodeFiwareString(search.name);
    copy.errorMessage = encodeFiwareString(search.errorMessage);

    copy.deleted = true;
    copy.active = false;

    const options: HttpOptions = {
      params: {
        options: 'keyValues'
      }
    };
    this.socicalMediaSearchHttpService.update(copy, UpdateActionType.APPEND, options)
      .subscribe(
        data => console.log('updated for delete search', data),
        err => console.log('error deleting search', err)
      );
  }

  getAll() {
    this.socicalMediaSearchHttpService.getAll()
      .pipe(map(res => res.filter(sm => !sm.deleted)))
      .subscribe(sm => this.store.add(sm));
  }

}
